import React, { useState } from 'react'
import { Grid, Button } from '@mui/material';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../components/Modal/modal'
import EditList from '../../components/EditList/EditList';
import axios from "axios"
import { URL } from '../../constants/constant';

const EditKeyWord = ({selectedRows, setOpen, setMessage, getTableData}) => {
    const [showModal, setShowModal] = useState(false);
    const [keyWordsList, setKeyWordsList] = useState([])

    const modalButtonClick = () => {
        if (selectedRows.length <= 0) {
            setOpen(true)
            setMessage('Please select a Package first')
            return
        }
        setKeyWordsList(selectedRows[0].keywords.split(', '))
        setShowModal(true)
    }

    const closeModal = () => {
        setKeyWordsList(selectedRows[0].keywords.split(', '))
        setShowModal(false)
    }

    const removeKeyWord = (keyName) => {
        if (keyWordsList.length === 1) {
            setOpen(true)
            setMessage('You can not remove all the keywords')
            return
        }
        setKeyWordsList(keyWordsList.filter((key) => key !== keyName));
    }

    const EditKeyWordAPI = () => {
        if (keyWordsList.join(', ') === selectedRows[0].keywords) {
            setOpen(true)
            setMessage('Please make changes before saving')
            return
        }
        const keyWordsListConcat = keyWordsList.join(',')

        const user = JSON.parse(localStorage.getItem("loggedInUserDetails")).emailId;

        const data = JSON.stringify({
            "subtest_name" : selectedRows[0].subtest_name,
            "newKeywords": keyWordsListConcat,
            "user": user
        });
        
        var config = {
            method: 'post',
            url: URL.demystify_url + 'knowledgeBase/editKeywords',
            headers: { 
            'Content-Type': 'application/json'
            },
            data : data
        };

        axios(config)
        .then(function (response) {
            if(response.data.success === 1){
                setOpen(true); 
                setMessage("Keyword edited succesfully"); 
                getTableData();
            }
            else if(response.data.success === 0){setOpen(false); setMessage(response.data.errorMessage);}
        })
        .catch(function (error) {
            alert("Something went wrong, please try again")
            console.log(error);
        });
        
        closeModal()
    }

    return (
        <Grid>
            <div className='add-keyword'>
                    <Button variant='contained' onClick={modalButtonClick}>
                        Edit Key Words
                    </Button>
                </div>

                <div>
                    <Modal show={showModal} setShow={setShowModal}>
                        <ModalHeader className='modal-header'>
                            <h2>Edit Key Words</h2>
                        </ModalHeader>
                        <ModalBody>
                            <div className='subtest-name' >
                                <div className='new-key-word' style={{justifyContent:'center'}}>
                                    <h3 style={{textAlign:'center',fontWeight:'bold'}}>Sub Test Name :<span>{selectedRows.length>0 ?selectedRows[0].subtest_name:undefined}</span></h3>
                                </div>
                            </div>
                            <EditList 
                                stateList={keyWordsList} 
                                removeItem={removeKeyWord}
                                setOpen={setOpen}
                                setMessage={setMessage}
                            />
                        </ModalBody>

                        <ModalFooter>
                            <Button variant="contained" style={{marginRight: 50}} onClick={EditKeyWordAPI}>Save</Button>
                            <Button onClick={closeModal} variant="outlined">
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
        </Grid>
    )
}

export default EditKeyWord